import { useUpdateScreenChatContext } from '$tablet-app/src/app/chat/hooks';
import { ScreenBackButton } from '$tablet-app/src/app/components/ScreenBackButton';
import { ScreenHeader } from '$tablet-app/src/app/components/ScreenHeader';
import { ScreenTitle } from '$tablet-app/src/app/components/ScreenTitle';
import { DeveloperScreenInfo } from '$tablet-app/src/app/developer/components/DeveloperScreenInfo/DeveloperScreenInfo';
import { RootStackScreenProps } from '$tablet-app/src/app/navigation/RootStackNavigator';
import { colors, spacing } from '@akin-home/theme';
import { showErrorToast } from '@akin-home/toast/native';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import styled from 'styled-components/native';
import { KnownRobotCard } from '../../components/KnownRobotsBar/KnownRobotCard';
import { useRobotStateStore } from '../../stores/useRobotStateStore';
import { RobotSettingsSwitch } from '../components/RobotSettingsSwitch';
import { RobotSettingsVolumeSlider } from '../components/RobotSettingsVolumeSlider';
import { RobotSoundSettingsSwitch } from '../components/RobotSoundSettingsSwitch';

export const RobotSettingsScreen = (
  props: RootStackScreenProps<'RobotSettings'>
) => {
  const {
    navigation: { goBack },
    route: {
      params: { robotId },
    },
  } = props;

  useUpdateScreenChatContext();
  // useEffect(() => {
  //   sendBackgroundMessage(intent_labels.open_create_checklist_screen);
  // }, []);

  const robot = useRobotStateStore((state) => state.robotDevices[robotId]);

  if (!robot) {
    showErrorToast({
      text1: 'Robot not found.',
    });
    goBack();
  }

  const isRobotConnected =
    robot?.websocketConnection?.connectionStatus === 'connected';

  return (
    <>
      <Screen>
        <Header>
          <ScreenBackButton onPress={goBack} />
          <ScreenTitle>Configure Robot Settings</ScreenTitle>

          <View style={styles.robotCardContainer}>
            {robot ? (
              <KnownRobotCard robot={robot} />
            ) : (
              <>
                <FontAwesomeIcon
                  icon={'warning'}
                  size={30}
                  style={{ height: '100%', width: '100%' }}
                  color={colors.yellow[700]}
                />
                <Text
                  style={{
                    textAlign: 'center',
                    textAlignVertical: 'center',
                    fontSize: 22,
                    color: colors.yellow[700],
                  }}
                >
                  Robot Not Available
                </Text>
              </>
            )}
          </View>
        </Header>

        <View style={styles.screen}>
          <RobotSettingsSwitch
            robot={robot}
            settingName={'mic_enabled'}
            style={styles.settingsSwitchContainer}
            switchProps={{
              containerStyle: styles.settingsSwitchInnerContainer,
            }}
            headerProps={{ icon: 'microphone', text: 'Microphone:' }}
            disabled={!isRobotConnected}
          />

          <RobotSettingsSwitch
            robot={robot}
            settingName={'sounds_enabled'}
            style={styles.settingsSwitchContainer}
            switchProps={{
              containerStyle: styles.settingsSwitchInnerContainer,
            }}
            headerProps={{ icon: 'volume', text: 'Master Sound:' }}
            disabled={!isRobotConnected}
          />

          <RobotSettingsVolumeSlider
            robot={robot}
            soundSettingName={'sounds_enabled'}
            style={styles.indentedSettingsSwitchContainer}
            headerProps={{ icon: 'volume', text: 'Master Volume:' }}
            disabled={!isRobotConnected}
          />

          <RobotSoundSettingsSwitch
            robot={robot}
            settingName={'ambient_sounds_enabled'}
            style={[
              styles.settingsSwitchContainer,
              styles.indentedSettingsSwitchContainer,
            ]}
            headerProps={{ icon: 'volume', text: 'Ambient Sound:' }}
            disabled={!isRobotConnected}
          />
        </View>
      </Screen>
      <DeveloperScreenInfo />
    </>
  );
};

const Screen = styled.View`
  flex: 1;
`;

const Header = styled(ScreenHeader)`
  justify-content: flex-start;
  gap: 20px;
  padding-bottom: 10px;
`;

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: 'white',
    margin: spacing[5],
    marginTop: 0,
    elevation: 3,
    borderRadius: 10,
  },
  robotCardContainer: {
    marginLeft: 'auto',
    flexDirection: 'row',
    gap: spacing[2],
  },
  settingsSwitchContainer: {
    justifyContent: 'flex-start',
    width: '17%',
    marginHorizontal: spacing[3],
    marginVertical: spacing[2],
  },
  indentedSettingsSwitchContainer: {
    justifyContent: 'flex-start',
    marginHorizontal: spacing[8],
    marginVertical: spacing[2],
  },
  settingsSwitchInnerContainer: {
    marginLeft: 'auto',
  },
});
